import * as React from "react";
type Props = {
  fill: string;
  width: number;
  height: number;
};
function CrossSvg(props: Props) {
  const { fill, width = 12, height = 12 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none">
      <path
        d="M11.025 0.975C10.725 0.675 10.275 0.675 9.975 0.975L6 4.95L2.025 0.975C1.725 0.675 1.275 0.675 0.975 0.975C0.675 1.275 0.675 1.725 0.975 2.025L4.95 6L0.975 9.975C0.675 10.275 0.675 10.725 0.975 11.025C1.125 11.175 1.275 11.25 1.5 11.25C1.725 11.25 1.875 11.175 2.025 11.025L6 7.05L9.975 11.025C10.125 11.175 10.35 11.25 10.5 11.25C10.65 11.25 10.875 11.175 11.025 11.025C11.325 10.725 11.325 10.275 11.025 9.975L7.05 6L11.025 2.025C11.325 1.725 11.325 1.275 11.025 0.975Z"
        fill={fill}
      />
    </svg>
  );
}

export default CrossSvg;
